// extracted by mini-css-extract-plugin
export default {"leaseTaxesEditorContainer":"_lease-taxes-editor_leaseTaxesEditorContainer__LfJqv"};